import axios, { type AxiosError } from "axios";
import { getUnmanagedApplicationInsights } from "@packsize/application-monitoring";
import { getUnmanagedBearerToken } from "@packsize/authentication";

export const packNetAxios = axios.create({});

packNetAxios.interceptors.request.use((config) => {
	const bearerToken = getUnmanagedBearerToken();

	if (!bearerToken) {
		return config;
	}

	config.headers.Authorization = bearerToken;

	return config;
});

packNetAxios.interceptors.request.use((config) => {
	config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";

	return config;
});

packNetAxios.interceptors.response.use(
	(response) => response,
	(error: AxiosError) => {
		if (error?.response?.status === 401 && !!error?.config?.headers?.Authorization) {
			getUnmanagedApplicationInsights().trackEvent({
				name: "API.Unauthorized",
				properties: {
					url: error.config.url,
				},
			});

			window.location.reload();
		}

		return Promise.reject(error);
	},
);
